/** The sitemap has one fixed position in Legal; hide older CMS-managed copies. */
export function isSitemapFooterLink(value: unknown, origin: string): boolean {
    if (typeof value !== 'string') return false;
    try {
        const url = new URL(value, origin);
        return (
            url.origin === new URL(origin).origin &&
            ['/sitemap.xml', '/nl/sitemap'].includes(url.pathname.replace(/\/$/, ''))
        );
    } catch {
        return false;
    }
}
